module.exports = __webpack_public_path__ + "img/promociones.8fd0aee9.svg";